import api from "./Api";

class OrdemServicoServicoService {
  GetOrdemServicoServico(payload) {
    return api.get("/v1/ordemServicoServico/" + payload).then((response) => {
      return response.data;
    });
  }

  PostOrdemServicoServico(payload) {
    return api.post("/v1/ordemServicoServico/", payload).then((response) => {
      return response.data;
    });
  }

  PutOrdemServicoServico(payload) {
    return api.put("/v1/ordemServicoServico/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteOrdemServicoServico(payload) {
    return api.delete("/v1/ordemServicoServico/" + payload).then((response) => {
      return response.data;
    });
  }

  GetOrdemServicoServicoOData(payload) {
    return api.get("/OData/OrdemServicoServico" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new OrdemServicoServicoService();
